/// The server sends a .NET TimeSpan, which is "hh:mm:ss.fffffff". Anything that is not one
/// counts as nothing: a NaN travels all the way to a scrubber and leaves it unusable.
export function toSeconds(duration: string): number {
  const [hours, minutes, seconds] = duration.split(':');

  return (Number(hours) || 0) * 3600 + (Number(minutes) || 0) * 60 + (Number(seconds) || 0);
}

/// What is left of something, in the units somebody thinks in.
export function formatRemaining(position: string, duration: string | null): string {
  if (!duration) {
    return '';
  }

  const left = Math.max(toSeconds(duration) - toSeconds(position), 0);
  const hours = Math.floor(left / 3600);
  const minutes = Math.round((left % 3600) / 60);

  return hours > 0 ? `${hours} h ${minutes} min` : `${minutes} min`;
}

/// The server sends a .NET TimeSpan, which is "hh:mm:ss.fffffff".
export function formatDuration(duration: string): string {
  const [hours, minutes] = duration.split(':');

  return Number(hours) > 0 ? `${Number(hours)} h ${Number(minutes)} min` : `${Number(minutes)} min`;
}

/// A running time the catalogue gives in minutes, written the way the library writes its own.
export function formatMinutes(total: number): string {
  const hours = Math.floor(total / 60);
  const minutes = total % 60;

  return hours > 0 ? `${hours} h ${minutes} min` : `${minutes} min`;
}

/// Season and episode as a person reads them off a disc or a guide: S01E03.
export function episodeCode(seasonNumber: number, episodeNumber: number): string {
  return `S${String(seasonNumber).padStart(2, '0')}E${String(episodeNumber).padStart(2, '0')}`;
}

/// A watch address turned into an embeddable one. Anything that is not a YouTube link is left
/// as it is, and the frame then shows whatever the provider serves.
export function embedUrl(url: string): string {
  try {
    const parsed = new URL(url);
    const key = parsed.searchParams.get('v');

    return parsed.hostname.endsWith('youtube.com') && key
      ? `https://www.youtube-nocookie.com/embed/${key}?autoplay=1`
      : url;
  } catch {
    return url;
  }
}
